<template>
  <div id="main-wrapper">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{$t('Create An Account')}}</h2>
          </div>
        </div>
      </div>
    </div>

    <section class="gray-simple">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-7 col-lg-8 col-md-9">
                    <div class="card border-0 rounded-4 p-xl-4 p-lg-4 p-md-4 p-3">
                        <div class="simple-form">
                            <div class="form-header text-center mb-5">
                            <div class="effco-logo mb-2">
                                <router-link class="d-flex align-items-center justify-content-center" to="/">
                                </router-link>
                            </div>
                            <h4 class="fs-2">{{$t('Create An Account')}}</h4>
                            </div>
                            <!-- User form -->
                            <form @submit.prevent="submitUserForm">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 mb-3">
                                        <label class="mb-1">{{ $t('Full Name') }}</label><span class="text-danger">*</span>
                                        <input type="text" class="form-control" v-model="form.name" :placeholder="$t('Full Name')" />
                                        <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
                                    </div>

                                    <div class="col-lg-6 col-md-6 mb-3">
                                        <label class="mb-1">{{ $t('Email') }}</label>
                                        <input type="email" class="form-control" v-model="form.email" :placeholder="$t('Your Email')" />
                                        <small class="text-danger" v-if="errors.email">{{ errors.email[0] }}</small>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 mb-3">
                                        <label class="mb-1">{{ $t('Password') }}</label><span class="text-danger">*</span>
                                        <input type="password" class="form-control" v-model="form.password" placeholder="*******" />
                                        <small class="text-danger" v-if="errors.password">{{ errors.password[0] }}</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <button
                                    type="submit"
                                    class="btn btn-primary full-width fw-medium"
                                    :disabled="loading"
                                    >
                                    <span v-if="loading">{{ $t('Please wait...') }}</span>
                                    <span v-else>{{ $t('Create An Account') }}</span>
                                    <i
                                        class="fa-solid px-2"
                                        :class="$i18n.locale === 'ar' ? 'fa-arrow-left-long' : 'fa-arrow-right-long'"
                                    ></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <FooterTop :bg="'theme-bg'" />

    <FooterDark />

    <ScrollToTop />
  </div>
</template>

<script setup>
import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import { ref } from 'vue'
import axios from 'axios'
import { useI18n } from "vue-i18n"
import { useToast } from "vue-toastification"
import { useRouter } from 'vue-router'

const toast = useToast()
const { t,locale } = useI18n()
const router = useRouter()
const loading = ref(false)
const errors = ref({})
const form = ref({
  name: '',
  email: '',
  password: '',
})

const submitUserForm = async () => {
  errors.value = {}
  let formValid = true

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const requiredFields = ['name', 'email', 'password']
  requiredFields.forEach((field) => {
    if (!form.value[field]) {
      errors.value[field] = [
        t('required', { field: t(`fields.${field}`) })
      ]
      formValid = false
    }
  })

  if (form.value.email && !emailRegex.test(form.value.email)) {
    errors.value.email = [t('invalid_email')]
    formValid = false
  }

  if (!formValid) return

  loading.value = true 

  try {
    const res = await axios.post('/users/visitor/register', {
      name: form.value.name,
      email: form.value.email,
      password: form.value.password,
    },{params: { lang: locale.value }})

    const userId = res.data.user_details.id
    const token = res.data.token

    localStorage.setItem('auth_token', token)
    localStorage.setItem('user_id', userId)

    form.value = { name: '', email: '', password: '' }
    errors.value = {}

    toast.success(t('Account created successfully! Please check your email for a verification code.'))

    router.push({
      path: `/${locale.value}/verify-email`,
      query: {
        email: res.data.user_details.email
      }
    });

  } catch (error) {
    if (error.response) {
      if (error.response.status === 422) {
        errors.value = error.response.data.errors || {}
        const msg = Object.values(errors.value).flat().join('\n')
        toast.error(msg)
      } else if (error.response.data?.message) {
        toast.error(error.response.data.message)
      } else {
        toast.error(t('An unexpected error occurred. Please try again.'))
      }
    } else {
      toast.error(t('Cannot connect to the server. Please try again later.'))
    }
  } finally {
    loading.value = false 
  }
}

</script>
